import STCConfirmation from './STCConfirmation';

export default STCConfirmation;
